import script from "./ChooseMaterialAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./ChooseMaterialAdd.vue?vue&type=script&setup=true&lang=js"

import "./ChooseMaterialAdd.vue?vue&type=style&index=0&id=60804e55&lang=less&scoped=true"

import exportComponent from "D:\\projectLy\\2025伟本\\weben-les-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60804e55"]])

export default __exports__